import { FC } from "react";
import * as Meta from 'meta';

export const Step: FC = () => {
  return (
    <div>
      {Meta.loadCSS(['notice', 'step'])}
      <section className="inner">
        <div id="step" className="step">
          <div className="title">
            <div className="title_t">爽啤一開，爽勁就來</div>
            <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
          </div>
          <div className="step_in">
            <ul className="step_box">
              <li className="step_s">
                <div className="step_num">step.1</div>
                <div className="step_pic"><img src="/resources/html/images/index/step1.png" /></div>
                <div className="step_text">購買貼有<br />活動貼紙的爽啤</div>
              </li>
              <li className="step_s">
                <div className="step_num">step.2</div>
                <div className="step_pic"><img src="/resources/html/images/index/step2.png" /></div>
                <div className="step_text">撕開罐身活動貼紙</div>
              </li>
              <li className="step_s">
                <div className="step_num">step.3</div>
                <div className="step_pic"><img src="/resources/html/images/index/step3.png" /></div>
                <div className="step_text">使用手機掃描<br />活動QRcode</div>
              </li>
              <li className="step_s">
                <div className="step_num">step.4</div>
                <div className="step_pic"><img src="/resources/html/images/index/step4.png" /></div>
                <div className="step_text">使⽤FB或Gmail<br />完成登錄</div>
              </li>
              <li className="step_s">
                <div className="step_num">step.5</div>
                <div className="step_pic"><img src="/resources/html/images/index/step5.png" /></div>
                <div className="step_text">詳閱活動辦法<br />及注意事項</div>
              </li>
              <li className="step_s">
                <div className="step_num">step.6</div>
                <div className="step_pic"><img src="/resources/html/images/index/step6.png" /></div>
                <div className="step_text">立即顯示，即掃即抽結果<br />填寫資料後還有機會獲得更多大獎</div>
              </li>
            </ul>
            <div className="step_next"><img src="/resources/html/images/index/step_next.png" /></div>
            <div className="step_bottom">
              <img className="step_shy shy1" src="/resources/html/images/index/step_shy1.png" />
              <div className="step_qrtext">趕快拿起手機<br />掃描活動QRcode囉！</div>
              <img className="step_shy shy2" src="/resources/html/images/index/step_shy2.png" />
            </div>
            <div className="step_qrbox">
              <img className="step_people" src="/resources/html/images/index/step_p1.png" />
              <div className="step_qrcode"><img src="/resources/html/images/index/step_qr.png" /></div>
              <img className="step_people" src="/resources/html/images/index/step_p2.png" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
